module.exports = __webpack_public_path__ + "web/img/pdf.ff4e5247.png";